import React, { useState, useEffect, useRef } from 'react'
import { Form, Formik } from 'formik';
import { NewsletterSubscribers } from 'model/screensModels/newsletterSubscribers/NewsletterSubscribers';
import NewsletterSubscribersSchema from 'schemas/newsletterSubscribers/NewsletterSubscribersSchema';
import FormikControl from 'components/wrapperComponents/FormikControl';
import { NewsletterSubscribersService } from 'services/menu/newsletterSubscribers/NewsletterSubscribersService';
import { msgTypes } from 'constants/msgTypes';
import FeaturedInNewsletterScreen from './FeaturedInNewsletterScreen';
import { Link } from 'react-router-dom';

const Footer = () => {
    const [initialValue, setInitialValue] = useState(new NewsletterSubscribers());
    const videoRef = useRef(null);
    
        useEffect(() => {
            if (videoRef.current) {
                videoRef.current.playbackRate = 1; // 0.5x speed (half speed)
            }
        }, []);

    //Prepare Data for API
    const prepareRequestBody = async (values) => {
        const prepareData = new NewsletterSubscribers();

        //to assing id based on action 
        if (("" + initialValue.newsletterSubscriberId)?.length > 0) {
            prepareData.newsletterSubscriberId = initialValue.newsletterSubscriberId;
        } else {
            prepareData.newsletterSubscriberId = values.newsletterSubscriberId ? values.newsletterSubscriberId : '';
        }

        prepareData.emailId = values.emailId ? values.emailId : '';

        return prepareData;

    }

    const onSubmit = async (values) => {
        const requestData = await prepareRequestBody(values);
        const res = await NewsletterSubscribersService.saveNewsletterSubscriber(requestData);
        if (res.statusMsg === msgTypes.SUCCESS.msg) {
            return true
        } else {
            return false
        }
    }

    const onButtonClick = () => {
        const pdfUrl = "/images/pdf/claim-procedure-1wn.pdf";
        const link = document.createElement("a");
        link.href = pdfUrl;
        // link.download = "document.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };



    return (
        <div>
            {/* Begin:: Get started  Newsletter*/}
            <FeaturedInNewsletterScreen />
            {/* End :: Get started Newsletter*/}

            {/* <!--Site Footer Start--> */}
            <footer className="site-footer">
               
                <div className='footer-section-top'>
                <div className="site-footer__top">
                    <div className="container">
                        <div className="site-footer__top-inner">
                            <div className="row">
                                <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                                    <div className="footer-widget__column footer-widget__about">
                                
                                        <div className="footer-widget__title-box">
                                            <h3 className="footer-widget__title">Our Offices</h3>
                                        </div>
                                        <ul className="footer-widget__about-contact list-unstyled">

                                            <li>
                                                <div className="icon">
                                                    <span className="icon-location location-icon"></span>
                                                </div>
                                                <p><h6 className='font-weight-bold text-white'>1WN headquarters</h6>
                                                    <a href='https://www.google.com/maps/place/DAFZ+-+Dubai+Airport+Free+Zone/@25.2604508,55.3702747,17z/data=!3m1!4b1!4m6!3m5!1s0x3e5f5db3d5235501:0xb8a647c098c4a23e!8m2!3d25.260446!4d55.372855!16s%2Fg%2F11b7hm0xgm?entry=tts&g_ep=EgoyMDI0MDkxNi4wKgBIAVAD' target='_blank'>#511, 8W Building,
                                                        DAFZ Dubai Airport, UAE </a></p>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <span className="icon-location location-icon"></span>
                                                </div>
                                                <p><h6 className='font-weight-bold text-white'>1WN Backend Office</h6>
                                                    <a href='https://www.google.com/maps/place/Radisson+Blu+Plaza+Hotel,+Delhi+Airport/@28.543838,77.1175718,17z/data=!4m9!3m8!1s0x390cfeb030000001:0x30ba15bbf06dfb74!5m2!4m1!1i2!8m2!3d28.5438333!4d77.1201521!16s%2Fg%2F11xy8yzzv?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D' target='_blank'>Radisson Blu Plaza Hotel,
                                                        Delhi Airport, INDIA</a></p>
                                            </li>
                                    
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                                    <div className="footer-widget__column footer-widget__company">
                                        <div className="footer-widget__title-box">
                                            <h3 className="footer-widget__title">Quick Links</h3>
                                        </div>
                                        <ul className="footer-widget__company-list list-unstyled">
                                       
                                            <li>
                                                <a href="/images/pdf/claim-procedure-1wn.pdf" target="_blank" rel="noopener noreferrer">Claim Procedure</a>
                                            </li>

                                            <li>
                                                {/* <!-- <a href="mission.html">Our Mission</a> --> */}
                                            </li>
                                            <li>
                                                <a href="/images/pdf/cookie-policy.pdf" target='_blank'>Cookie Policy</a>
                                            </li>
                                            <li>
                                                <a href="/images/pdf/privacy-policy.pdf" target='_blank'>Privacy Policy</a>
                                            </li>
                                            <li>
                                                <a href="/images/pdf/terms-and-conditions-1wn.pdf" target='_blank'>Terms and Conditions</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                                    <div className="footer-widget__column footer-widget__services">
                                        <div className="footer-widget__title-box">
                                            <h3 className="footer-widget__title">Highlights</h3>
                                        </div>
                                        <ul className="footer-widget__services-list list-unstyled">
                                            <li>
                                                <Link to="/upcoming-events"><span className="icon-angle-left"></span>1WN Events</Link>
                                            </li>
                                            <li>
                                                <Link to="/membership-center" activeClassName="active-link"><span className="icon-angle-left"></span>1WN Membership Center</Link>
                                            </li>
                                            <li>
                                                <Link to="/news-and-media"><span className="icon-angle-left"></span>1WN News & Media</Link>
                                            </li>
                                            <li>
                                                <Link to="/about-us" activeClassName="active-link"><span className="icon-angle-left"></span>About us</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
                                    <div className="footer-widget__column footer-widget__newsletter">
                                        <div className="footer-widget__title-box">
                                            <h3 className="footer-widget__title">Newsletter</h3>
                                        </div>

                                        <Formik
                                            enableReinitialize={true}
                                            initialValues={initialValue}
                                            validationSchema={NewsletterSubscribersSchema}
                                            onSubmit={async (values, { resetForm }) => {
                                                const res = await onSubmit(values);
                                                if (res) {
                                                    resetForm();
                                                }
                                            }}
                                        >
                                            {
                                                ({ isValid, setFieldValue, dirty, isSubmitting, values }) => (
                                                    <Form className="footer-widget__newsletter-form ">
                                                        <div className="footer-widget__newsletter-form-input-box">
                                                            <FormikControl control='textfield'
                                                                name='emailId'
                                                                className='form-control'
                                                                placeholder="Email"
                                                            />
                                                            <button type="submit" className="footer-widget__newsletter-btn" disabled={!dirty || !isValid}>
                                                                <span className="icon-paper-plane" ></span>
                                                            </button>
                                                        </div>
                                                    </Form>
                                                )
                                            }
                                        </Formik>

                                        <div className="mc-form__response"></div>
                                    </div>
                                    <ul className="footer-widget__about-contact list-unstyled mt-4">
                                        <li>
                                            <div className="icon">
                                                <span className="icon-envolop email-icon"></span>
                                            </div>
                                            <p><a href="mailto:debra.holt@example.com" target="_blank" rel="noopener noreferrer">info@oneworldnetwork.co</a></p>
                                        </li>
                                        <li>
                                            <div className="icon">
                                                <span className="icon-call phone-call"></span>
                                            </div>
                                            <p><a href="tel:+971 54 522 3903" target="_blank" rel="noopener noreferrer">+971 54 522 3903</a></p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="site-footer__bottom">
                    <div className="container">
                        <div className="site-footer__bottom-inner text-center">
                            <p className="site-footer__bottom-text">©2026 All Rights Reserved, Designed & Developed by <a
                                href="https://csgtech.in/" target="_blank"> CSG.</a></p>
                        </div>
                    </div>
                </div>
                </div>
                <div className='footer-event-one'>
                <video ref={videoRef} autoPlay muted loop playsInline>
                    <source src="https://www.oneworldnetwork.co/video/1wn-footer.mp4" type="video/mp4" />
                </video>
                </div>



            </footer>
            {/* Site FooterEnd */}
        </div>
    )
}

export default Footer
